import { Outlet, useLocation } from 'react-router-dom';
import { useEffect, Suspense } from 'react';
import { Events } from '@constants';
import { isAuthFreeRoute } from '@utils/path';
import { updateStore } from '@app/store';
import 'react-tooltip/dist/react-tooltip.css';
import '../../index.scss';
import { Loading } from '@leegality/leegality-react-component-library';
import { cn } from '@utils/general';
import { getSdkHostWindow } from '@utils/parent-messenger';
import ModalManager from '@components/modals/modalManager';
import AuthProvider from '@app/providers/auth-provider';
// import { Toaster } from '@leegality/leegality-react-component-library/dist/toast';

const RootLayout = () => {
  useEffect(() => {
    // Listen for messages from parent SDK
    const handleMessage = (event) => {
      if (event.data && event.data.eventType) {
        switch (event.data.eventType) {
          case Events.CONFIG_FROM_SDK: {
            const { data } = event.data;

            // Set SDK configuration in store. sdkData is deliberately narrow —
            // only the fields consumed downstream (font selectors + cookie-center
            // components). Top-level flags are hoisted so they don't duplicate.
            updateStore({
              isWebSdk: data.isWebSdk || false,
              isAndroidSdk: data.isAndroidSdk || false,
              isIosSdk: data.isIosSdk || false,
              sdkData: data,
            });
            break;
          }
          case Events.COOKIE_DATA_UPDATE: {
            const { data } = event.data;
            const { profileData, availableCategories, selectedLocale } = data;

            // Get current sdkData and update it with cookie category data and the
            // locale the SDK fetched it in
            const currentState = window.useStore.getState();
            const updatedSdkData = {
              ...currentState.sdkData,
              profileData,
              availableCategories,
              selectedLocale,
            };

            updateStore({
              sdkData: updatedSdkData,
            });
            break;
          }
          default:
            break;
        }
      }
    };

    // Add message listener
    window.addEventListener('message', handleMessage);

    // Send IFRAME_READY to the web SDK (parent page in iframe mode, the opener in popout mode)
    const sdkHost = getSdkHostWindow();
    if (sdkHost) {
      sdkHost.postMessage({
        eventType: Events.IFRAME_READY,
        data: {},
      }, '*');
    }

    // Cleanup
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  const location = useLocation();
  const currentPath = location.pathname;

  const shouldBypassAuth = isAuthFreeRoute(currentPath);

  const content = (
    <div className={cn('flex flex-col h-[calc(100vh-0rem)] overflow-hidden')}>
      <ModalManager.Provider>
        {/* Suspense boundary for lazy-loaded route surfaces (code splitting). */}
        <Suspense fallback={null}>
          <Outlet />
        </Suspense>
        {/* <Toaster /> */}
      </ModalManager.Provider>
    </div>
  );

  return shouldBypassAuth ? content : <AuthProvider>{content}</AuthProvider>;
};

export default RootLayout;
